import { useContext } from 'react';
import { ConfigContext } from 'src/configContext';
import { RegionsEnum } from 'src/generated/operations';
import { UNIT_SWITCH_COUNTRIES } from 'src/sensors/constants';
import { useLocationState } from 'src/sensors/useLocationState.ts';

export const useImperial = () => {
    const { userSettings } = useContext(ConfigContext);
    const [locationState] = useLocationState();

    const showSwitch = UNIT_SWITCH_COUNTRIES.includes(userSettings.currentCountry);

    if (locationState.isImperial !== null) {
        return {
            isImperial: locationState.isImperial,
            showSwitch,
        };
    }

    if (showSwitch) {
        return {
            isImperial: false,
            showSwitch: true,
        };
    }

    return {
        isImperial: userSettings.currentRegion === RegionsEnum.Am,
        showSwitch,
    };
};
